// extracted by mini-css-extract-plugin
export default {"switchBtn":"SwitchBtn_switchBtn__m0aCT","switchOn":"SwitchBtn_switchOn__gJRFf"};